<style scoped>
.sensor-status-msg {
  text-align: center;
}

.settings-page .battery-block .icon {
  height: 40px;
  background-color: white;
  margin: 10px 0 0 60px;
  width: 50px;
}

.settings-page .signal-block .icon {
  height: 35px;
  background-color: white;
  margin: 10px 0 0 60px;
  width: 45px;
}

.settings-page .battery-block .text-info-after-input-block p,
.settings-page .signal-block .text-info-after-input-block p {
  margin: 17px 0 0 0;
}

.sensor-serial-number {
  padding: 20px 0 0 75px;
}

.control-group-checkbox-block {
  padding: 20px 0 0 75px;
}

.control-group-msg {
  padding: 40px 0 0 0;
  margin-bottom: 0;
  text-align: center;
}

.control-group-msg .msg-block {
  text-align: center;
}

.warning-auto-close-block .text-info-after-input-block p {
    margin: 12px 0;
}
</style>

<template>
<div class="col-12 settings-page">
  <div class="loader loader-in-group-settings" v-if="loader_block">
    <loader-component></loader-component>
  </div>
  <div v-if="!loader_block">
    <div class="offset-md-3 col-md-6">
      <msg-component :type_msg="msg_general.type" :text="msg_general.text"></msg-component>
    </div>
    <div class="col-12 row input-setting-block">
      <div class="offset-1 col-1 elips"></div>
      <div class="col-2 item-name">
        Имя датчика
      </div>
      <div class="col-7">
        <input v-bind:class="{fail: name_msg}" type="text" v-model="sensor_name">
    </div>
        <div v-if="name_msg" class="offset-4 col-7 after-input-msg">
          <p>{{name_msg}}</p>
        </div>
        <div class="offset-4 col-7 text-info-after-input-block">
          <p>Название датчика, будет отображаться в списке сенсоров</p>
        </div>
      </div>
      <div class="offset-3 col-6" v-if="warning_status == 'warn'">
        <msg-component class="sensor-status-msg" :type_msg="'alert'" :text="'Датчик в состоянии тревоги'"></msg-component>
      </div>
      <div class="col-12 row input-setting-block">
        <div class="offset-1 col-1 elips"></div>
        <div class="col-2 item-name">
          Уникальный идентификатор
        </div>
        <div class="col-7 sensor-serial-number">
          <h3>ID {{sensor_number}}</h3>
        </div>
        <div class="offset-4 col-7 text-info-after-input-block" v-if="faucet_sensor == true">
            <p>Проводной датчик крана</p>
        </div>
      </div>
      <div class="col-12 row input-setting-block battery-block" v-if="group_sensor == true">
        <div class="offset-1 col-1 elips"></div>
        <div class="col-2 item-name">
          Питание датчика
        </div>
        <div class="col-2">
          <div class="icon" :class="getPowerIconClass" v-if="getPowerIconClass"></div>
        </div>
        <div class="col-5 text-info-after-input-block">
          <p>Питание датчика: от батарей или внешнего источника </p>
        </div>
      </div>
      <div class="col-12 row input-setting-block signal-block" v-if="group_sensor == true">
        <div class="offset-1 col-1 elips"></div>
        <div class="col-2 item-name">
          Связь
        </div>
        <div class="col-2">
          <div class="icon" :class="getSignalIconClass"></div>
        </div>
        <div class="col-5 text-info-after-input-block">
          <p>Качество связи</p>
        </div>
      </div>
      <div class="col-12 row input-setting-block warning-auto-close-block" v-if="group_sensor == true || faucet_sensor == true">
        <div class="offset-1 col-1 elips"></div>
        <div class="col-2 item-name">
          Закрыть при тревоге
        </div>
        <div class="col-2 warning-auto-close-checkbox-block">
          <input  id="warning-auto-close"
                v-model="warning_auto_close" type="checkbox" autocomplete="off">
          <label for="warning-auto-close">.</label>
        </div>
        <div class="col-5 text-info-after-input-block">
          <p>Краны, работающие в автоматическом режиме, будут закрываться</p>
        </div>
      </div>

      <!-- TODO кнопку не в пункте и редизайн под стиль aquazor -->
      <div v-if="!faucet_sensor">
        <div class="offset-md-3 col-md-6 control-group-msg" v-if="msg_sensor_group.text">
          <msg-component :type_msg="msg_sensor_group.type" :text="msg_sensor_group.text"></msg-component>
        </div>
        <div class="col-12 row input-setting-block" v-if="group_sensor == true">
          <div class="offset-1 col-1 elips"></div>
          <div class="col-2 item-name">
            Удалить из группы
          </div>
          <div class="col-7 control-group-checkbox-block">
            <button class="btn btn-danger" @click="removeFromGroup">Убрать из группы</button>
          </div>
          <div class="offset-4 col-7 text-info-after-input-block">
            <p>Удалить этот датчик из доступных группе. Максимальное количество датчиков для группы 32, не считая проводной.</p>
          </div>
        </div>
        <div class="col-12 row input-setting-block" v-else>
          <div class="offset-1 col-1 elips"></div>
          <div class="col-2 item-name">
            Добавить в группу
          </div>
          <div class="col-7 control-group-checkbox-block">
            <button class="btn btn-success" @click="addToGroup">Добавить в группу</button>
          </div>
          <div class="offset-4 col-7 text-info-after-input-block">
            <p>Сделать доступным группе этот датчик. Максимальное количество датчиков для группы 32, не считая проводной.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import msg from './elements/msg.vue'
import axios from 'axios'
import config from '@/config.js'
import loader from './elements/loader.vue'
import {
  store
} from '@/store'

export default {
  created() {
    GetGroupSettings(this)
    get_sensor_statuses_start(this)
  },
  components: {
    'v-select': vSelect,
    'loader-component': loader,
    'msg-component': msg,
  },
  data() {
    return {
      msg_general: {
        type: 'hidden',
        text: ''
      },
      msg_sensor_group: {
        type: 'hidden',
        text: ''
      },
      sensor_name: null,
      loader_block: true,
      save_status: true,
      name_msg: '',
      warning_auto_close: null,
      signal: null,
      power: null,
      warning_status: 'norm',
      sensor_number: '',
      connection: false,
      sensor_setting_page_status: true,
      group_sensor: null,
      faucet_sensor: null
    }
  },
  destroyed() {
    this.save_status = false
  },
  watch: {
    sensor_name: function (this_sensor_name, old_sensor_name) {
      if (old_sensor_name != null && this_sensor_name != old_sensor_name) {
        setTimeout(() => {
          if (this_sensor_name == this.sensor_name) {
            saveName(this_sensor_name, this)
          }
        }, 1000)
      }
    },
    history_status: function (this_history_status, old_history_status) {
      if (old_history_status != null && this_history_status != old_history_status) {
        saveAddHistory(this_history_status, this)
      }
    },
    warning_auto_close: function (this_warning_auto_close_status, old_warning_auto_close_status) {
      if (old_warning_auto_close_status != null && this_warning_auto_close_status != old_warning_auto_close_status) {
        saveAutoClose(this_warning_auto_close_status, this)
      }
    },
  },
  methods: {
    addToGroup: function () {
      addSensorToGroup(this)
    },
    removeFromGroup: function () {
      removeSensorFromGroup(this)
    }
  },
  computed: {
    getSignalIconClass: function () {
      var signal_class = 'signal-0'
      if (this.signal == 11) {
        signal_class = 'signal-1'
      } else if (this.signal == 12) {
        signal_class = 'signal-2'
      } else if (this.signal == 13) {
        signal_class = 'signal-3'
      } else if (this.signal == 14) {
        signal_class = 'signal-4'
      } else if (this.signal == 15) {
        signal_class = 'signal-5'
      } else if (this.signal == 16) {
        signal_class = 'battery-cable-power'
      }
      if (!this.connection) {
        signal_class = 'signal-0'
      }
      return signal_class
    },
    getPowerIconClass: function () {
      var power_class = 'battery-cable-power'
      if (this.power > 0 && this.power <= 4) {
        power_class = 'battery-' + this.power
      }
      else if (this.power == 5) {
        power_class = false
      }
      return power_class
    }
  },
  destroyed() {
    this.sensor_setting_page_status = false
  },
}

function GetGroupSettings(vue_obj) {
  var post_data = new FormData()
  post_data.set('token', localStorage.token)
  post_data.set('id_sensor', vue_obj.$route.params.id_sensor)
  post_data.set('id_group', vue_obj.$route.params.id_group)

  axios({
      method: 'POST',
      url: config.API_HOST + '/sensors/get_sensor',
      data: post_data
    })
    .then(function (response) {
      if (!!response.data.name) {
        vue_obj.sensor_name = response.data.name
      }
      if (!!response.data.serial_number) {
        var serial_number = response.data.serial_number.split("-").join("")
        serial_number = serial_number.toUpperCase()
        if (serial_number.length > 0) {
            serial_number = serial_number.match(new RegExp('.{1,4}', 'g')).join("-")
        }
        vue_obj.sensor_number = serial_number
      }
      if (typeof response.data.auto_close_faucet !== "undefined") {
        vue_obj.warning_auto_close = response.data.auto_close_faucet
      }
      if (typeof response.data.power !== "undefined") {
        vue_obj.power = response.data.power
      }
      if (typeof response.data.signal !== "undefined") {
        vue_obj.signal = response.data.signal
      }
      if (typeof response.data.status !== "undefined") {
        vue_obj.warning_status = response.data.status
      }
      if (typeof response.data.connection !== "undefined") {
        vue_obj.connection = response.data.connection
      }
      if (typeof response.data.group_sensor !== "undefined") {
        vue_obj.group_sensor = response.data.group_sensor
      }
      if (typeof response.data.faucet_sensor !== "undefined") {
        vue_obj.faucet_sensor = response.data.faucet_sensor
      }
      vue_obj.loader_block = false
    })
    .catch(function (error) {
      console.log(error.response.data)
    })
}

function saveName(new_name, vue_obj) {
  vue_obj.msg_general = {
    type: 'hidden',
    text: ''
  }
  vue_obj.name_msg = ''
  var post_data = new FormData()
  post_data.set('token', localStorage.token)
  post_data.set('id_sensor', vue_obj.$route.params.id_sensor)
  post_data.set('sensor_name', vue_obj.sensor_name)

  axios({
      method: 'POST',
      url: config.API_HOST + '/sensors/change_sensor_name',
      data: post_data
    })
    .then(function (request) {
      console.log(request)
    })
    .catch(function (error) {
      if (!!error.response.data.exception) {
        vue_obj.name_msg = field_exception['exception']
      }
    })
}

function saveAddHistory(new_add_history_status, vue_obj) {
  vue_obj.msg_general = {
    type: 'hidden',
    text: ''
  }
  var post_data = new FormData()
  post_data.set('token', localStorage.token)
  post_data.set('id_sensor', vue_obj.$route.params.id_sensor)
  post_data.set('sensor_add_to_history', new_add_history_status)

  axios({
      method: 'POST',
      url: config.API_HOST + '/sensors/change_sensor_add_to_history',
      data: post_data
    })
    .then(function (request) {
      console.log(request)
    })
    .catch(function (error) {
      console.log(error)
    })
}

function saveAutoClose(new_auto_close_status, vue_obj) {
  vue_obj.msg_general = {
    type: 'hidden',
    text: ''
  }
  var post_data = new FormData()
  post_data.set('token', localStorage.token)
  post_data.set('id_sensor', vue_obj.$route.params.id_sensor)
  post_data.set('sensor_auto_close_faucet', new_auto_close_status)

  axios({
      method: 'POST',
      url: config.API_HOST + '/sensors/change_sensor_auto_close_faucet',
      data: post_data
    })
    .then(function (request) {
      console.log(request)
    })
    .catch(function (error) {
      console.log(error)
    })
}

function get_sensor_statuses_start(vue_obj) {
  if (vue_obj.sensor_setting_page_status) {
    get_sensor_statuses(vue_obj)
    setTimeout(function () {
      get_sensor_statuses_start(vue_obj)
    }, config.UPDATE_PERIOD)
  }
}

function get_sensor_statuses(vue_obj) {
  if (!!localStorage.token && vue_obj.sensor_setting_page_status) {
    var post_data = new FormData()
    post_data.set('token', localStorage.token)
    post_data.set('id_sensor', vue_obj.$route.params.id_sensor)
    post_data.set('id_group', vue_obj.$store.getters.id_group)

    axios({
        method: 'POST',
        url: config.API_HOST + '/sensors/get_sensor',
        data: post_data
      })
      .then(function (response) {
        if (typeof response.data.power !== "undefined") {
          vue_obj.power = response.data.power
        }
        if (typeof response.data.signal !== "undefined") {
          vue_obj.signal = response.data.signal
        }
        if (typeof response.data.connection !== "undefined") {
          vue_obj.connection = response.data.connection
        }
        if (typeof response.data.group_sensor !== "undefined") {
          vue_obj.group_sensor = response.data.group_sensor
        }
        if (typeof response.data.status !== "undefined") {
            vue_obj.warning_status = response.data.status
        }
        if (typeof response.data.auto_close_faucet !== "undefined") {
            vue_obj.warning_auto_close = response.data.auto_close_faucet
        }
        vue_obj.loader_block = false
      })
      .catch(function (error) {
        console.log(error.response.data)
      })
  }
}

function removeSensorFromGroup(vue_obj) {
  vue_obj.loader_block = true
  vue_obj.msg_sensor_group = {
    type: 'hidden',
    text: ''
  }
  var post_data = new FormData()
  post_data.set('token', localStorage.token)
  post_data.set('id_sensor', vue_obj.$route.params.id_sensor)

  axios({
      method: 'POST',
      url: config.API_HOST + '/sensors/move_sensor_from_group',
      data: post_data
    })
    .then(function (request) {
      console.log(request)
      get_sensor_statuses(vue_obj)
    })
    .catch(function (error) {
      if (error.response.data.exception) {
        vue_obj.msg_sensor_group = {
          type: 'alert',
          text: error.response.data.exception
        }
      }
    })
}

function addSensorToGroup(vue_obj) {
  vue_obj.loader_block = true
  vue_obj.msg_sensor_group = {
    type: 'hidden',
    text: ''
  }
  var post_data = new FormData()
  post_data.set('token', localStorage.token)
  post_data.set('id_sensor', vue_obj.$route.params.id_sensor)

  axios({
      method: 'POST',
      url: config.API_HOST + '/sensors/move_sensor_to_group',
      data: post_data
    })
    .then(function (request) {
      console.log(request)
      get_sensor_statuses(vue_obj)
    })
    .catch(function (error) {
      if (error.response.data.exception) {
        vue_obj.msg_sensor_group = {
          type: 'alert',
          text: error.response.data.exception
        }
      }
    })
}
</script>



// WEBPACK FOOTER //
// src/components/sensor-settings.vue